/**
 *
 * Styles for WCCMultiBUOfferPriceAndPaymentInfo
 *
 */

import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { Headline } from "root/libs/ui-components/src";
import VatInfoMessage from "one-time-shipment/src/components/Offers/VatInfoMessage";

export const CardPriceHeadline = styled(Headline)`
  margin: ${(props) => props.bottomMargin};

  @media screen and (max-width: ${breakpoints.tablet}) {
    font-size: var(--dui-size-font-3xl) !important;
    line-height: 1.8125rem !important;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0;
  }
`;

export const CardPriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media screen and (min-width: ${breakpoints.tablet}) {
    align-items: center;
  }

  @media print {
    width: 30%;
  }

  .price-label > *:is(p, span) {
    color: var(--dui-color-black-500);
    margin: var(--dui-size-space-5x) 0;

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-bottom: var(--gaq-size-space-3px);
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      margin-bottom: 0;
    }
  }
`;

export const CardButtonWrapper = styled.div`
  margin-bottom: 5px;

  button {
    width: 100%;
  }

  @media print {
    display: none;
  }
`;

export const DisclaimerStar = styled.span`
  font-weight: 200;
`;

export const StyledVatInfoMessage = styled(VatInfoMessage)`
  top: 0;
  right: 10px;
  color: var(--dui-color-red-500);
  background-color: var(--dui-color-white-500);
  border: 1px solid var(--dui-color-red-500);
  padding: var(--dui-size-space-2x) var(--dui-size-space-5x);

  & > dhl-button {
    line-height: var(--dui-size-line-height-xs) !important;
    font-size: var(--dui-size-font-2xs) !important;

    & > .styled.text.link:is(button, a) {
      padding: 0 !important;
      font-size: var(--dui-size-font-2xs) !important;
      line-height: var(--dui-size-line-height-xs) !important;
      border-radius: 0 !important;
      border: 0 !important;

      & span {
        font-size: inherit !important;
        line-height: inherit !important;
        font-weight: 400;
      }
    }
  }

  @media screen and (min-width: 1150px) {
    top: 0;
    right: 0;
  }
`;

export const PaymentInfoAndVatMessageWrapper = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.isPaymentIcons ? "space-between" : "flex-end"};
  padding-top: ${(props) =>
    props.isInvoiceOnly ? "var(--gaq-size-space-5px)" : 0};
  align-items: baseline;

  @media screen and (min-width: ${breakpoints.tablet}) {
    align-items: center;
  }

  @media print {
    width: 30%;
  }
`;
